import { startCase } from "lodash";
import billingLabels from "../../constants/billingLabels";

const getBillingLabel = (key, entry) => {
  if (typeof entry?.label === "string" && entry.label.trim()) {
    return entry.label.trim();
  }

  return billingLabels[key] ?? startCase(key);
};

export default getBillingLabel;
